import { publicApiInstance } from '../client'

export const getDefaultFeeSet = () =>
  publicApiInstance()
    .get('/fees/fee-set/default')
    .then((res) => res.data)
